// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "result": {
      "column": {
        "default": null,
        "name": "result",
        "null": false,
        "type": "string"
      },
      "name": "result",
      "selected_by_default": null,
      "translated": null
    },
    "translated_result": {
      "column": null,
      "name": "translated_result",
      "selected_by_default": false,
      "translated": null
    },
    "blank_votes_count": {
      "column": {
        "default": 0,
        "name": "blank_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "blank_votes_count",
      "selected_by_default": null,
      "translated": null
    },
    "no_trust_votes_count": {
      "column": {
        "default": 0,
        "name": "no_trust_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "no_trust_votes_count",
      "selected_by_default": null,
      "translated": null
    },
    "trust_votes_count": {
      "column": {
        "default": 0,
        "name": "trust_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "trust_votes_count",
      "selected_by_default": null,
      "translated": null
    },
    "yes_votes_count": {
      "column": {
        "default": 0,
        "name": "yes_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "yes_votes_count",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "VoteElectionPostContactResult",
  "collectionKey": "vote_election_post_contact_results",
  "collectionName": "vote_election_post_contact_results",
  "i18nKey": "vote_election_post_contact_result",
  "camelizedLower": "voteElectionPostContactResult",
  "name": "VoteElectionPostContactResult",
  "nameDasherized": "vote-election-post-contact-result",
  "pluralName": "vote_election_post_contact_results",
  "ransackable_associations": [
    {
      "className": "ElectionPostContact",
      "collectionName": "election_post_contacts",
      "foreignKey": "election_post_contact_id",
      "name": "election_post_contact",
      "macro": "belongs_to",
      "resource_name": "ElectionPostContact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "VoteElectionPostResult",
      "collectionName": "vote_election_post_results",
      "foreignKey": "vote_election_post_result_id",
      "name": "vote_election_post_result",
      "macro": "belongs_to",
      "resource_name": "VoteElectionPostResult",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "blank_votes_count",
      "column": {
        "default": 0,
        "name": "blank_votes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "election_post_contact_id",
      "column": {
        "default": null,
        "name": "election_post_contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "no_trust_votes_count",
      "column": {
        "default": 0,
        "name": "no_trust_votes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "old_election_post_contact_id",
      "column": {
        "default": null,
        "name": "old_election_post_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "result",
      "column": {
        "default": null,
        "name": "result",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "trust_votes_count",
      "column": {
        "default": 0,
        "name": "trust_votes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vote_election_post_result_id",
      "column": {
        "default": null,
        "name": "vote_election_post_result_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "yes_votes_count",
      "column": {
        "default": 0,
        "name": "yes_votes_count",
        "null": false,
        "type": "integer"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "vote_election_post_contact_result",
  "primaryKey": "id"
}

/** Frontend model for VoteElectionPostContactResult. */
export default class VoteElectionPostContactResult extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  result() {
    return this.readAttributeUnderscore("result")
  }

  /** @returns {boolean} */
  hasResult() {
    const value = this.result()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedResult() {
    return this.readAttributeUnderscore("translated_result")
  }

  /** @returns {boolean} */
  hasTranslatedResult() {
    const value = this.translatedResult()

    return this._isPresent(value)
  }

  /** @returns {number} */
  blankVotesCount() {
    return this.readAttributeUnderscore("blank_votes_count")
  }

  /** @returns {boolean} */
  hasBlankVotesCount() {
    const value = this.blankVotesCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  noTrustVotesCount() {
    return this.readAttributeUnderscore("no_trust_votes_count")
  }

  /** @returns {boolean} */
  hasNoTrustVotesCount() {
    const value = this.noTrustVotesCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  trustVotesCount() {
    return this.readAttributeUnderscore("trust_votes_count")
  }

  /** @returns {boolean} */
  hasTrustVotesCount() {
    const value = this.trustVotesCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  yesVotesCount() {
    return this.readAttributeUnderscore("yes_votes_count")
  }

  /** @returns {boolean} */
  hasYesVotesCount() {
    const value = this.yesVotesCount()

    return this._isPresent(value)
  }
}
